import React, { useState } from "react";
import { Configuration, OpenAIApi } from "openai";
import Loader from "react-js-loader";


export default function ArticleGenerator(props) {
    const [topic, setTopic] = useState("");
    const [wordCount, setWordCount] = useState("");
    const [textResult, setTextResult] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    const OPENAI_API_KEY = "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";

  //using openAI
  const blog_post = async () => {
    setIsLoading(true)
    const configuration = new Configuration({
      apiKey: OPENAI_API_KEY
    });
    const openai = new OpenAIApi(configuration);

    const response = await openai.createCompletion({
      model: "text-davinci-003",
      prompt: "generate a in detail article on "+ topic +" in "+ wordCount +" words." ,
      temperature: 0,
      max_tokens: 2000,
      top_p: 1.0,
      frequency_penalty: 0.0,
      presence_penalty: 0.0,
    });
    const response_str = response.data.choices[0].text;
    const response_list = response_str.split("\n")
    setTextResult(response_list);
    setIsLoading(false)

    props.showAlert("Blog Post Generated ", "success");
  };

  const handleOnChange_topic = (e) => {
    setTopic(e.target.value);
  };

  const handleOnChange_wordCount = (e) => {
    setWordCount(e.target.value);
  };

  return (
    <div className={`text-${props.mode === "light" ? "dark" : "light"}`}>
      <p
        style={{
          marginTop: "10px",
          textAlign: "center",
          fontSize: "40px",
          fontFamily: "sans-serif",
          fontVariant: "small-caps",
          fontWeight: 600,
        }}
      >
        {" "}
        Article Generator
      </p>
      {isLoading ? (
        <>
        <div className="row"
             style={{
                      padding:"20px"
                    }}>
          <Loader type="bubble-loop" bgColor={"#5C0091"} size={150} /> 
        </div>
        </>
      ) : 
      (<>
      <div className="row">
        <div className="col-md-6 my-2">
            <textarea
            className="form-control"
            placeholder="Blog Topic"
            value={topic}
            id="blog_topic"
            rows="1"
            onChange={handleOnChange_topic}
            style={{
                backgroundColor: props.mode === "dark" ? "grey" : "white",
                color: props.mode === "dark" ? "white" : "black",
            }}
            ></textarea>
        </div>
        <div className="col-md-6 my-2">
            <textarea
            className="form-control"
            placeholder="Word Count"
            value={wordCount}
            id="No_of_words"
            rows="1"
            onChange={handleOnChange_wordCount}
            style={{
                backgroundColor: props.mode === "dark" ? "grey" : "white",
                color: props.mode === "dark" ? "white" : "black",
            }}
            ></textarea>
        </div>
    </div>

    <div className="row">
        <div className="col-md-3 "></div>
        <div className="col-md-6 mx-2 my-2">
            <button
                type="button"
                className={`btn btn-${
                props.mode === "dark" ? "dark" : "secondary"
                } my-2 mx-2`}
                onClick={blog_post}
                style={{ width: "100%", height: "100%" }}
            >
                Generate Blog Post
            </button>
        </div>
        <div className="col-md-1 "></div>
    </div>

    <div className="row">
        <div className="col-md-2"></div>
        <div className="col-md-8">
          <p
            style={{
              fontSize: "30px",
              fontFamily: "sans-serif",
              fontVariant: "small-caps",
              fontWeight: 600,
              textAlign: "center",
              paddingTop: "15px",
            }}
          >
              {" "}
              {textResult.length === 0 ? "" : "Article:"}
          </p>
        </div>
        <div className="col-md-2">
        {textResult.length === 0 ? "" : 
        <>
          <button
            type="button"
            className={`btn btn-${
            props.mode === "dark" ? "dark" : "danger"
            } my-2 mx-2`}
            onClick={() => {
              navigator.clipboard.writeText(textResult);
              props.showAlert("Textbox Copied", "success");
            }}
            style={{ width: "100%", height: "100%" }}
          >
              Copy to Clipboard
          </button>
        </>
        }
        
        </div>
    </div>

    <div className="row">
        <div className="col-md-2"></div>
        <div className="col-md-8">
            {textResult.map((item, index) => (
              <p style={{
                textAlign:"justify"
              }}
              key={index}
              >
                {item}
              </p>
            ))
            }
        </div>
        <div className="col-md-2"></div>
    </div>
      </>
      )
      }
    </div>
  );
};

